module.exports = __webpack_public_path__ + "img/hr-tank-base-4.0c6330a4.png";